import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../navigation/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class RefreshGuardService {
  constructor(
    private readonly router: Router,
    private readonly navigationService: NavigationService
  ) {}

  canActivate(): boolean {
    if (this.isPageRefresh()) {
      // On démarre une nouvelle navigation, on doit donc passer manuellement les query params
      this.navigationService.naviguerVersAccueilSurRefresh(window.location.search);
    }
    return true;
  }

  private isPageRefresh(): boolean {
    return !this.router.navigated;
  }
}
